// Datos de contacto de Kiwi Dinámico: el ÚNICO lugar donde se cambian. Los usan
// el pie, la página de contacto, la de Nosotros y los botones de WhatsApp.
//
// Regla: aquí no va nada que la empresa no haya confirmado. Un dato vacío no se
// muestra (mejor nada que un número de mentira como el +123456789 que había).
import { WHATSAPP_NUMBER } from './subproductos';

export { WHATSAPP_NUMBER };

// WhatsApp en formato legible (el mismo número que el sitio ya publicaba).
export const WHATSAPP_VISIBLE = '+506 8822-8785';

export const CORREO = 'info@kiwidinamico.com';

// TELEFONO_PENDIENTE: Adán tiene que confirmar si hay una línea fija o un número
// distinto del WhatsApp (TESTI-14). Mientras esté vacío, el pie y Contacto no
// muestran la fila «Teléfono»; al llenarlo (p. ej. '+506 2XXX-XXXX') aparece sola.
export const TELEFONO = '';

// Sin dirección física publicada: no se inventa una. El pie dice «Costa Rica».
export const UBICACION = 'Costa Rica';

// Redes sociales oficiales. Vacío a propósito: en el repo no hay ninguna cuenta
// confirmada. Formato: { nombre: 'LinkedIn', url: 'https://...' }.
export const REDES = [];

// Arma el enlace de WhatsApp con un mensaje ya escrito, para que la persona no
// tenga que pensar cómo empezar la conversación.
export const enlaceWhatsApp = (mensaje = 'Hola, quiero conversar sobre la tecnología de mi empresa.') =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensaje)}`;

// Enlace al formulario de contacto con asunto y mensaje precargados.
export const enlaceContacto = (asunto, mensaje) => {
  const params = new URLSearchParams();
  if (asunto) params.set('subject', asunto);
  if (mensaje) params.set('message', mensaje);
  const qs = params.toString();
  return qs ? `/contacto?${qs}` : '/contacto';
};
